import { useAssignSetting, useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { MY_ORDERS_V4_241021 } from "@faire/web-api--source/indigofair/settings/MY_ORDERS_V4_241021";
export var useSettingMyOrdersV4 = function() {
    return useSetting(MY_ORDERS_V4_241021, false);
};
export var useAssignSettingMyOrdersV4 = function() {
    return useAssignSetting(MY_ORDERS_V4_241021);
};
